import image from '../../img/layouts/layout-preview-side-menu.png';

export const preview = {
  image,
  description: 'Side Menu',
};
